import { getTestId } from '@airtel/air-design-system';
var expandCtaData = {
  expandedCtaTitle: 'View More',
  collapseCtaTitle: 'Show Less',
  initialItemCount: 4,
  expandedIconName: 'DownChevronButtonIcon',
  collapseIconName: 'UpChevronButtonIcon'
};
export var defaultProps = Object.assign(Object.assign({
  id: 'ScrollListContainer',
  showExpandCta: false,
  expandCtaData: expandCtaData,
  showCtaOnContainer: true,
  ctaOnContainerTitle: 'Add New Connections',
  buttonType: 'primary',
  data: Array.from({
    length: 10
  }, () => ({
    avatarIcon: 'UserEnclosedIcon',
    heading: 'Primary SIM',
    subHeading: '75 GB/m',
    indicatorType: 'infoTag',
    indicatorTypeProps: {
      infoTagText: 'test',
      infoTagType: 'offer'
    }
  }))
}, getTestId('ScrollLinkListWidgetContainer')), {
  style: {
    borderRadius: 16
  },
  cardTitleProps: {
    title: 'page Content title',
    subTitle: 'subtext'
  }
});